import FeaturesPlate from './FeaturesPlate'

export default FeaturesPlate
